import React, { Component } from 'react'
import { graphql, StaticQuery } from 'gatsby'
import chevron from '../../../static/chevron_right.svg'
import logo from '../../../static/p_icon_color_badge.png'
import { KEYBOARD_CLOSED, KEYBOARD_OPENED } from '../../globals/events'
import styles from './main.scss'
import cn from 'classnames'
import get from 'lodash/get'

class Badge extends Component {
  constructor(props) {
    super(props)
    this.unmounted = false
    this.state = { shouldRender: false, badgeVisible: true }
  }

  get utmParams() {
    const { data } = this.props
    const utm_campaign = get(data, 'campaignData.companyId')
    const utm_term = get(data, 'campaignData._id')

    return `?utm_source=badge&utm_medium=perspective-badge&utm_campaign=${utm_campaign}&utm_term=${utm_term}`
  }

  get badgeLink() {
    const { data } = this.props
    const affiliateLink = get(data, 'campaignData.affiliateLink')

    if (!affiliateLink) {
      return `https://perspective.co/${this.utmParams}`
    }

    return `${affiliateLink}/${this.utmParams}`
  }

  componentDidMount() {
    this.addKeyboardEventListeners()
    this.delayActivation()
  }

  isMobile() {
    return window.screen.width < 928
  }

  addKeyboardEventListeners = () => {
    if (this.isMobile) {
      window.addEventListener(KEYBOARD_OPENED, this.toggleBadge)
      window.addEventListener(KEYBOARD_CLOSED, this.toggleBadge)
    }
  }

  removeKeyboardEventListeners = () => {
    window.removeEventListener(KEYBOARD_OPENED, this.toggleBadge)
    window.removeEventListener(KEYBOARD_CLOSED, this.toggleBadge)
  }

  toggleBadge = event => {
    const eventType = event.type
    const badgeVisible = eventType === KEYBOARD_CLOSED

    this.setState({
      ...this.state,
      badgeVisible,
    })
  }

  componentWillUnmount() {
    this.removeKeyboardEventListeners()
    this.unmounted = true
  }

  delayActivation() {
    setTimeout(() => {
      if (this.unmounted) {
        return
      }
      this.setRender()
    }, 1000)
  }

  setRender() {
    if (!this.state.shouldRender) {
      this.setState({
        ...this.state,
        shouldRender: true,
      })
    }
  }

  render() {
    if (!get(this.props.data, 'campaignData.showBadge')) {
      return null
    }

    const wrapperClass = cn(styles.wrapper, {
      [styles.active]: this.state.shouldRender && this.state.badgeVisible,
    })

    return (
      <div className={styles.positioner}>
        <a className={wrapperClass} href={`${this.badgeLink}`} target="_blank" rel="noopener noreferrer">
          <div className={styles.left}>
            <img className={styles.image} src={logo} alt="perspective logo" />
          </div>
          <div className={styles.center}>
            <div className={styles.big}>Try for free!</div>
            <div className={styles.smallWrapper}>
              <div className={styles.powered}>
                <span role="img" aria-label="lightning bolt">
                  ⚡
                </span>
                ️
              </div>
              <div className={styles.smallText}>by perspective</div>
            </div>
          </div>
          <div className={styles.right}>
            <img src={chevron} alt="chevron right" />
          </div>
        </a>
      </div>
    )
  }
}

Badge.propTypes = {}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        campaignData {
          _id
          showBadge
          companyId
          affiliateLink
        }
      }
    `}
    render={data => <Badge data={data} {...props} />}
  />
)
